import { useState } from 'react';
import { chordLongName, parseChord } from '../../core/theory';
import { ChordDiagram } from '../../ui/ChordDiagram';
import { Tabs } from '../../ui/widgets';
import { ToolShell } from './ToolShell';

type Cat = 'acik' | 'barre' | 'yedi' | 'maj7';

const CATS: { id: Cat; label: string; list: string[] }[] = [
  {
    id: 'acik',
    label: 'Açık akorlar',
    list: ['C', 'D', 'E', 'G', 'A', 'Am', 'Dm', 'Em', 'Asus2', 'Asus4', 'Dsus2', 'Dsus4', 'Esus4'],
  },
  {
    id: 'barre',
    label: 'Barre akorlar',
    list: ['F', 'Bb', 'B', 'Eb', 'Ab', 'Db', 'F#', 'Bm', 'Cm', 'Fm', 'Gm', 'F#m', 'C#m', 'G#m', 'Bbm', 'Ebm'],
  },
  {
    id: 'yedi',
    label: "7'li akorlar",
    list: ['E7', 'A7', 'D7', 'G7', 'C7', 'B7', 'F7', 'Bb7', 'Am7', 'Dm7', 'Em7', 'Bm7', 'F#m7', 'Cm7', 'Gm7'],
  },
  {
    id: 'maj7',
    label: "Majör 7'li ve diğer",
    list: ['Cmaj7', 'Fmaj7', 'Gmaj7', 'Dmaj7', 'Amaj7', 'Emaj7', 'Bdim', 'Adim', 'Aaug', 'Csus4', 'Gsus4'],
  },
];

export function ChordLibrary() {
  const [cur, setCur] = useState<Cat>('acik');
  const cat = CATS.find((c) => c.id === cur) ?? CATS[0];
  return (
    <ToolShell
      title="Akor kütüphanesi"
      desc="Şemaya dokununca akor çalar. Barre akorlar için perde numarası şemanın yanında yazar."
      icon="chordbox"
    >
      <div>
        <Tabs items={CATS} active={cur} onChange={setCur} />
      </div>
      <div className="lib-grid">
        {cat?.list.map((n) => {
          const c = parseChord(n);
          if (!c) return null;
          return (
            <ChordDiagram key={n} chord={n} caption={chordLongName(c.root, c.q, /^[A-G]b/.test(n) || undefined)} />
          );
        })}
      </div>
    </ToolShell>
  );
}
